import styled from 'styled-components';

export const FormAnswerDetailStyled = styled.div`
  #btn-success {
  }
`;
